module.exports = __webpack_public_path__ + "static/EDING_Telecom_Logo_white-28279c521a601f6e5ae31d873dd1f6bc.svg";